const MenuCustomerService = [
  {
    path: "aivoluon.com",
    icon: "fas fa-globe text-green",
    title: "aivoluon.com",
  },
  
  {
    path: "/drive",
    icon: "fa fa-cloud text-lightpink",
    title: "Yourdrive",
    badge: "10",
    children: [
      { path: "/drive/yourdrive", title: "yourdrive" },
      { path: "/drive/search_yourdrive", title: "Search in your drive" },
      { path: "itransportindex.com:4321/dbApp", title: "Mongoose DB" },
    ],
  },

  {
    path: "/kaizen",
    icon: "fas fa-ticket-alt text-indigo",
    title: "Kaizens",
    
    children: [
      { path: "/kaizen/kaizens", title: "Manage Kaizens" },
      { path: "/kaizen/gridkaizens", title: "Grid-kaizens" },      
      { path: "/kaizen/wastetypes", title: "Manage Wastetypes" },      
      { path: "/kaizen/actions", title: "Manage Actions" },      
      { path: "/kaizen/timelinekaizens", title: "Timeline of Kaizens" },      	  
    ],
  },

  {
    path: "/kanban",
    icon: "fas fa-ticket-alt text-indigo",
    title: "Kanban",
    
    children: [
      { path: "/kanban/kanbans", title: "Manage Kanbans" },
      { path: "/kanban/gridkanbas", title: "Grid kanbans" },      
      { path: "/kanban/listkanbans", title: "List Kanbans" },      
      { path: "/kanban/tasks", title: "Tasks" },      	  	  
      { path: "/kanban/timelinetasks", title: "Timeline of Tasks" },      	  
    ],
  },

  {
    path: "/Accounting",
    icon: "fas fa-balance-scale text-cyan",
    title: "Accounting",
    badge: "10",
    children: [
      { path: "/accounting/accountingsetting", title: "Setting" },	
      { path: "/accounting/invoices", title: "Invoices" },
      { path: "/accounting/invoices/new", title: "Add Invoice" },
      { path: "/accounting/expenses", title: "Expenses" },
      { path: "/accounting/expenses/new", title: "Add Expense" },
      { path: "/accounting/transactions", title: "Transactions" },
      { path: "/accounting/transactions/new", title: "Add transaction" },
      { path: "/accounting/COAs", title: "COAs" },
	  { path: "/accounting/NCOAs", title: "COAs" },	  
      { path: "/accounting/COAs/new", title: "Add COA" },
      { path: "/accounting/services", title: "Services" },
      { path: "/accounting/services/new", title: "Add Service" },
      { path: "/accounting/products", title: "Products" },
      { path: "/accounting/products/new", title: "Add Product" },
      { path: "/accounting/profitlossstatement", title: "Profit vs Loss Statement"},
      { path: "/accounting/charts", title: "Charts" },
    ],
  },

  {
    path: "/Ticket",
    icon: "fas fa-ticket-alt text-olive",
    title: "Tickets",
    badge: "10",
    children: [
      { path: "/ticket/tickets", title: "Tickets" },
      { path: "/ticket/tickets/new", title: "Add Ticket" },
      { path: "/ticket/grid-tickets", title: "Gridview of Tickets" },
      { path: "/ticket/timelinetickets", title: "Timeline of Tickets" },
      { path: "/ticket/search_tickets", title: "Search in Tickets" },
    ],
  },
  
];

export default MenuCustomerService;
